module.exports = __webpack_public_path__ + "img/plus.bea0d113.svg";